import { Component, Element, h, Host, JSX, Prop } from '@stencil/core';

@Component({
  tag: 'rcm-columns',
  styleUrl: 'rcm-columns.scss',
  shadow: false,
})
export class RcmColumns {
  /** Should the children be centered */
  @Prop() public centerChildren = false;

  /** breaks columns to multiple rows */
  @Prop() public multipleRows = false;

  /** Vertical alignment in columns */
  @Prop() public vAlign: boolean;

  /** Value of the gap property between columns */
  @Prop() public columnGap: string;

  @Prop() public direction: 'row' | 'column' = 'row';

  @Prop() public alignItems: string;

  /** Keep column span on mobile */
  @Prop() spanMobile: boolean;

  @Prop() spanTablet: number;

  @Element() private element: HTMLRcmColumnsElement;

  public componentWillRender(): void {
    const columnsClasses = {
      columns: true,
      'is-centered': this.centerChildren,
      'is-multiple-row': this.multipleRows,
      'is-vcentered': this.vAlign,
      'is-variable': true,
      // gutter should be 0 when < medium, container max width will take care of margins
      'is-0-mobile': true,
      // gutter should be 24px when > medium
      'is-3-tablet': !!this.spanTablet,
      // gutter should be 16px when > large
      'is-4-desktop': true,
      'is-mobile': this.spanMobile,
      'is-flex-direction-column': this.direction === 'column',
      'is-align-items-center': this.alignItems === 'center',
    };
    if (this.spanTablet) {
      columnsClasses[`is-${this.spanTablet}-tablet`] = true;
    }
    // This is only needed due to the grid-system using Bulma under-the-hood
    Object.keys(columnsClasses).forEach((item) => {
      this.element.classList[columnsClasses[item] ? 'add' : 'remove'](item);
    });

    if (this.columnGap) {
      this.element.style.setProperty('--columnGap', this.columnGap);
    }
  }

  public render(): JSX.Element {
    return (
      <Host>
        <slot />
      </Host>
    );
  }
}
